import { useWebSiteStore } from '@/stores/web-site.store'
import { useCurrency } from '@/composables/currency'

export const useRateCard = () => {
  const webSiteStore = useWebSiteStore()
  const { getCurrencyString } = useCurrency()

  const currencyCode = (o) => o?.rc_currency_ref_code || webSiteStore.currencies.find(c => c.id === o?.rc_currency_ref)?.code
  const unitSymbol = (o) => webSiteStore.getLocalizedUnitsOfMeasure().find(u => u.id === o?.rc_unit_of_measure_ref)?.symbol
  const vatLabel = (o) => webSiteStore.getLocalizedVatTypes().find(v => v.id === o?.rc_vat_type_ref)?.name

  const amountLabel = (value, o, withUnit) => {
    const code = currencyCode(o)
    if (value == null || !code) return ''
    const amount = getCurrencyString(value, code)
    const unit = unitSymbol(o)
    return withUnit && unit ? `${amount} / ${unit}` : amount
  }

  const priceLabel = (o, withUnit = false) => amountLabel(o?.rc_price, o, withUnit)
  const costLabel = (o, withUnit = false) => amountLabel(o?.rc_cost, o, withUnit)

  const hasRateCard = (o) => [priceLabel(o), costLabel(o), unitSymbol(o), vatLabel(o)].some(Boolean)

  return { currencyCode, unitSymbol, vatLabel, priceLabel, costLabel, hasRateCard }
}
